
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const GuidePage = lazy(() => import('../pages/guide/page'));
const PurchasePage = lazy(() => import('../pages/purchase/page'));
const SupportPage = lazy(() => import('../pages/support/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/guide',
    element: <GuidePage />,
  },
  {
    path: '/purchase',
    element: <PurchasePage />,
  },
  {
    path: '/support',
    element: <SupportPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
